import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/diagram/biz-min.svg")